<script>
export default {
    name: "UnpostedBillDetails",

    data() {

        return {
            patient: {},
            billItems: [],
        };
    },

    computed: {
      
      grandTotal() {

          if(!this.billItems.length) return 0;

          const billItemsFiltered = this.billItems.filter(billI => billI.total);

          if(!billItemsFiltered.length) return 0;

          const billItems = billItemsFiltered.map(billI => parseFloat(billI.grandTotal));

          return billItems.reduce((gTotal, accTotal) => gTotal + accTotal);
      },
    },

    mounted() {

        Promise.allSettled([this.fetchPatientBillItems(), this.fetchPatient(), ]).then(() => {
            window.print();
            window.onafterprint = function() { window.close(); };
        }).catch(() => {});
    },

    methods: {

        fetchPatientBillItems() {

            return this.$http.get(`AccountsReports/GetUnPostedBillsPatientItems?PatientID=${this.$route.query.patientID}`).then(response => {
                this.billItems = response.data;
            }).catch(() => {});
        },

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.query.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full my-2 text-center">
            <h5 class="font-bold text-base">Patient Bill Items</h5>
        </div>
        <div class="w-full flex flex-row">
            <div class="flex-1">
                <h5 class="font-medium">{{ patient.names }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">IPFile No: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">OPFile No: {{ patient.opfileno}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">MRN: {{ patient.patienT_ID }}</h5>
            </div>
        </div>
        <table class="table table-bordered">
            <thead class="text-xs">
                <tr>
                    <th class="p-tiny">#</th>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">User</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Discount</th>
                    <th class="p-tiny">Tax</th>
                    <th class="p-tiny">L.Total</th>
                    <th class="p-tiny">Net Total</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(billItem, idx) in billItems" :key="idx">
                    <td class="p-tiny">{{ billItem.invoiceDetailID }}</td>
                    <td class="p-tiny">{{ billItem.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ billItem.userName }}</td>
                    <td class="p-tiny">{{ billItem.itemName }}</td>
                    <td class="p-tiny">{{ billItem.description }}</td>
                    <td class="p-tiny">{{ billItem.quantity }}</td>
                    <td class="p-tiny">{{ billItem.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.discount | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.tax | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.lineTotal | numberFormat }}</td>
                    <td class="p-tiny">{{ billItem.grandTotal | numberFormat }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny"></th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">{{ grandTotal | numberFormat }}</th>
                </tr> 
            </tfoot>
        </table>
    </div>
</template>
